import React from 'react';
import PropTypes from 'prop-types';
import { DealerReviewGoodView } from 'site-modules/dealerships/components/dealer-review-good-view/dealer-review-good-view';
import { DealerReviewNoReviewsView } from 'site-modules/shared/components/dealer-review-no-reviews-view/dealer-review-no-reviews-view';
import { ReviewEntities } from 'client/data/models/dealer-reviews';
import { DEFAULT_REVIEWS_TYPE, DEALER_PROPS } from 'client/constants/dealer-reviews';

export function DealerReviewsView({
  overallData = {},
  featuredReview = null,
  reviewsType = DEFAULT_REVIEWS_TYPE,
  showroomPage = '',
  params,
  isMobile = false,
}) {
  if (overallData && overallData.totalCount) {
    return (
      <DealerReviewGoodView
        reviewsType={reviewsType}
        overallData={overallData}
        featuredReview={featuredReview}
        params={params}
        showroomPage={showroomPage}
        isMobile={isMobile}
      />
    );
  }

  return (
    <DealerReviewNoReviewsView
      reviewsType={reviewsType}
      params={params}
      showroomPage={showroomPage}
      isMobile={isMobile}
    />
  );
}

DealerReviewsView.propTypes = {
  params: DEALER_PROPS.isRequired,
  reviewsType: PropTypes.string,
  overallData: ReviewEntities.OverallRatingEntity,
  featuredReview: ReviewEntities.ReviewEntity,
  showroomPage: PropTypes.string,
  isMobile: PropTypes.bool,
};
